import { render, staticRenderFns } from "./bulkOrder.vue?vue&type=template&id=4820a115&"
import script from "./bulkOrder.vue?vue&type=script&lang=js&"
export * from "./bulkOrder.vue?vue&type=script&lang=js&"
import style0 from "./bulkOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports